<template>
  <div class="mentIndex">
    <div class="home_con_index">
      <div style="width:306px"></div>
      <div class="mentCon">
        <div class="ment_title">接口规范</div>
        <p>1.1 查询充电站信息</p>
        <span
          >概述：1）此接口用于数据需求方从聚能平台查询同步充电站信息<br />
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          2）聚能从基础设施运营商查询同步充电站信息<br />
          接口名称：query_stations_info<br />
          接口使用方法：用户运营方调用聚能（不允许多线程并发调用），聚能调用基础设施运营商</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/gg.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/hh.png" alt="" />
        <p>1.2 设备状态变化推送</p>
        <span
          >概述：当设备状态发生变化时，基础设施运营商推送最新状态到聚能，聚能再推送最新的状态到客户归属运营商<br />
          接口名称：notification_stationStatus<br />
          接口使用方法：由数据需求方实现此接口，聚能调用</span
        ><br />
        <small>请求参数：</small>
        <img src="@/assets/ment/jj.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/4.png" alt="" />
        <p>1.3 设备接口状态查询</p>
        <span
          >概述：用于批量查询设备实时状态<br />
          接口名称：query_station_status<br />
          接口使用方法：由聚能和基础设施运营商实现此接口，数据需求方调用</span
        >
        <small>请求参数：</small>
        <img src="@/assets/ment/5.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/6.png" alt="" />
        <p>1.4充电站状态推送</p>
        <span
          >概述：充电站发生状态变化或价格变化后，实时推送给聚能，聚能实时推送给客户运营商<br />
          接口名称：notification_stationInfo<br />
          接口使用方法：客户运营商实现此接口，聚能调用。聚能实现此接口，设备运营商调用</span
        >
        <small>请求参数：</small>
        <img src="@/assets/ment/7.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/8.png" alt="" />
        <p>1.5上线站点查询接口</p>
        <span
          >概述：此接口用于聚能查询用户运营商上线的聚能合作方的充电站信息，用户运营商返回的结果集应与其APP展现的站点列表一致。聚能将查询结果与聚能本地配置的开放策略比对，以便及时发现用户运营商漏上、错上站点的情况。<br />
          接口名称：query_stations_online_info<br />
          接口使用方法：由用户归属运营商实现，聚能调用</span
        >
        <small>请求参数：</small>
        <img src="@/assets/ment/9.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/10.png" alt="" />
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
};
</script>

<style scoped>
.home_con_index {
  display: flex;
  text-align: left;
}
.mentCon small {
  margin: 23px 0px 12px 0px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 12px;
}
.mentCon img {
  margin: 0px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documente.vue